<template>
  <section>
    <modal :title="title" :show="showModal" @close="closeModal()" largebox="true">
      <div class="content flex center" slot="content">
        <div class="flex-1 flex center column margin-top-l">
          <div class="w100">
            <div class="">
              <p>
                1) Você precisa instalar a TAG do Hot Tracker.
              </p>
              <p>
                2) Adicionar o código de acompanhamento em todos seus anúncios.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="action" slot="action">
        <div class="flex center">
          <button @click="closeModal()" class="button primary medium">
            Fechar
          </button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import Modal from "@/components/modal/Modal";

export default {
  name: "modal-guia-tracking",
  props: {
    titleName: {
      required: false,
      default: "Como ativar as UTMS",
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "false",
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      showDeleteModal: false,
      selectModalDelete: null,
      showModal: false,
      seenGuide: {},
      codeTrack: "utm_campaign={{campaign.name}}&utm_source={{placement}}&utm_content={{ad.name}}&utm_medium=CGA{{campaign.id}}_{{adset.id}}_{{ad.id}}",
      title: "Como ativar as UTMS",
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  margin-top: 30px;
  .button {
    margin-left: 10px !important;
  }
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 500px;
  min-width: 500px;
  min-height: 150px;
  max-height: 150px;
}

ul {
  list-style: none;
  max-height: 200px;
  overflow-y: scroll;
  li {
    padding: 4px 8px;
    border-bottom: 1px solid #ccc;
    .tag {
      background: #c2c2c2;
      padding: 4px 6px;
      border-radius: 5px;
      font-size: 11px;
      font-weight: 800;
      margin-left: 8px;
    }
    .button {
      margin-left: 4px;
      padding: 4px 6px;
    }
  }
}
</style>
